import axios from "axios";
import { ACLMasterResponse } from "../shared/interface/MasterManagement/accessControl.interface";
import { ModuleAndIdMapping, Modules } from "../constants/DatabaseConstants/MasterConstant";
import { AdvanceBookingQuotaList } from "../shared/interface/MasterManagement/advanceBookingQuota.interface";

export const getOneMasterListById = async (id: number, showDeleted?: boolean | null, customerId?: number | null | undefined, locationId?: number | null | undefined, clientId?: number | null, keyFobId?: number | null) => {
  let query = `${process.env.REACT_APP_API_URL}/master/${id}`;

  /* Initialize URLSearchParams to manage query parameters */
  const params = new URLSearchParams();

  if (showDeleted) {
    params.append("showDeleted", String(showDeleted));
  }

  if (customerId) {
    params.append("customerId", String(customerId));
  }

  if (locationId) {
    params.append("locationId", String(locationId));
  }

  if (clientId) {
    params.append("clientId", String(clientId));
  }

  if (keyFobId) {
    params.append("keyFobId", String(keyFobId));
  }

  /* Append query parameters */
  if (params.toString()) {
    query += `?${params.toString()}`;
  }

  try {
    const response = await axios.get(query);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addMasterAPI = async (formData: object) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/master/`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateMasterAPI = async (id: number, formData: object) => {
  try {
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/master/${id}`, formData);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const bulkUpdateMasterAPI = async (formData: object) => {
  try {
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/master/bulk/update`, formData);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteMasterAPI = async (modelId: number, id: number) => {
  try {
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/master/change-record-status/${modelId}/${id}`, {});

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAccessControlMasterAPI = async (modelId: number, roleId: number) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/master/${modelId}?roleId=${roleId}`);

    return response.data as ACLMasterResponse;
  } catch (error) {
    throw error;
  }
};

export const getAdvanceBookingQuotaList = async (customerId: number, customerLocationId: number) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/master/${ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER]}?customerId=${customerId}&locationId=${customerLocationId}`);

    return response.data.AllRecordsList as AdvanceBookingQuotaList;
  } catch (error) {
    throw error;
  }
};
